import React from 'react';
import './reject-css.css';
import AuthNav from '../../auth/nav/Nav';

const Reject = () => (
    <div>
        <AuthNav/>
        <div id="reject-div-1a">Bye bye</div>
    </div>
);

export default Reject;


// WEBPACK FOOTER //
// ./src/components/auth/reject/Reject.js